// Utilidad para renderizar Markdown seguro y bonito
import React from "react";
import { marked } from "marked";

export default function MarkdownRenderer({ markdown = "" }) {
  // Configura marked para sanitizar y soportar listas, saltos de línea, etc.
  const html = marked.parse(markdown, {
    breaks: true,
    gfm: true,
  });

  return (
    <div
      className="prose prose-invert max-w-none text-white [&_a]:break-all [&_*]:max-w-full"
      dangerouslySetInnerHTML={{ __html: html }}
    />
  );
}
